import React, { Component } from 'react'
import { Modal, ModalFooter, Row, Col } from 'reactstrap'
import styled from 'styled-components'
import StyledButton from '../Forms/Button'

import { withNamespaces } from 'react-i18next'

import Preloader from '../UI/Preloader'

const StyledModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 30px 35px 30px;

  font-family: 'Open Sans', sans-serif;
  font-weight: 500;
`

const StyledTitle = styled.div`
  margin-bottom: 30px;
  font-size: 13px;
  text-align: center;
  color: #19233c;
  text-transform: uppercase;
`

const ModalFooterWrapper = styled(ModalFooter)`
  padding-bottom: 0 !important;
  border: none !important;
`

class ApproveWorkRequestModal extends Component {
  state = {
    modal: false
  }

  approveWorkRequestHandler = () => {
    this.props.approveWorkRequest()
    this.closeModal()
  }

  closeModal = () => {
    this.props.toggle()
  }

  render() {
    const { isOpen, t, loading } = this.props
    const { comment } = this.state

    return (
      <Modal
        isOpen={isOpen}
        toggle={this.closeModal}
        contentClassName="styled_modal_content"
      >
        {loading && <Preloader />}
        <StyledModalContent>
          <StyledTitle>{t('tickets:approve')}</StyledTitle>

          <ModalFooterWrapper>
            <StyledButton onClick={this.closeModal} outline bgColor="#fff">
              {t('common:cancel')}
            </StyledButton>
            <StyledButton onClick={this.approveWorkRequestHandler}>
              {t('tickets:approve')}
            </StyledButton>
          </ModalFooterWrapper>
        </StyledModalContent>
      </Modal>
    )
  }
}

export default withNamespaces()(ApproveWorkRequestModal)
